/**
 * CONFIGURAÇÕES: AS REGRAS DA ESCRITA (11/10/2026, medição de Credenciais, Integrações, Prestadoras, Sessões e
 * Retenção S3). Funções puras que as telas usam e os testes cobram dos dois lados.
 */

/**
 * D2: conexões que o backend só "testa" conferindo se a variável de ambiente existe (system-credentials.service:
 * checkClicksignConnection, checkSmtpConnection). Até ele chamar o serviço de verdade, o card não pode sair verde.
 */
export const NAO_TESTADAS = ['clicksign', 'smtp'];
export const FRASE_DO_NAO_TESTADO = 'Configurado (não testado): o HUB só confere se o token existe, não se o serviço aceita.';

/** D3: o confirm de encerrar/revogar UM nomeia o que sai (rótulo, IP, último uso); antes era um clique, sem pergunta. */
export function confirmacaoDeEncerrarSessao(s: { label: string; ipAddress: string | null; ultimaAtividade: string }, quando: string) {
  return {
    title: 'Encerrar esta sessão?',
    message: `${s.label}${s.ipAddress ? ` · ${s.ipAddress}` : ''} · última atividade ${quando}.`,
    consequence: 'Aquele navegador precisa fazer login de novo.',
    confirmLabel: 'Encerrar',
    danger: true,
  };
}

export function confirmacaoDeRevogarDispositivo(d: { label: string | null; ipAddress: string | null }, ultimoUso: string | null) {
  return {
    title: 'Revogar este dispositivo?',
    message: `${d.label || 'Dispositivo'}${d.ipAddress ? ` · ${d.ipAddress}` : ''}${ultimoUso ? ` · último uso ${ultimoUso}` : ''}.`,
    consequence: 'O código do MFA volta a ser pedido no próximo login daquele navegador. Se for este, é o seu próximo login.',
    confirmLabel: 'Revogar',
    danger: true,
  };
}

/** D3: lista de segurança que não carrega não pode dizer "nenhuma": quem confere se há alguém na conta lê "ninguém". */
export const fraseDaListaDeSegurancaQueNaoLeu = (oQue: string, motivo: string) =>
  `Não consegui ler ${oQue} (${motivo}). Isso não quer dizer que não haja.`;

/**
 * D4: os DDRs apontam para a prestadora por ID (`carrierId` = Operadora Real, `hostCarrierId` = hospedagem), não por
 * texto como o confirm antigo dizia. `null` = os DDRs não foram lidos, e então não dá para saber.
 */
export function usoDaPrestadora(id: number, ddrs: Array<{ carrierId?: number | null; hostCarrierId?: number | null }> | null): number | null {
  if (!ddrs) return null;
  return ddrs.filter((d) => Number(d.carrierId) === id || Number(d.hostCarrierId) === id).length;
}

export const ddrsPorExtenso = (n: number) => `${n.toLocaleString('pt-BR')} DDR${n === 1 ? '' : 's'}`;

export function fraseDoRenomear(uso: number | null): string {
  if (uso === null) return 'O nome sai em todos os DDRs que usam esta prestadora: renomear muda em todos.';
  if (uso === 0) return 'Nenhum DDR usa esta prestadora hoje.';
  return `Renomeia em ${ddrsPorExtenso(uso)}: o nome exibido vem daqui.`;
}
